import { render, staticRenderFns } from "./SwitchRenderer.vue?vue&type=template&id=0e608e04"
import script from "./SwitchRenderer.vue?vue&type=script&lang=js"
export * from "./SwitchRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports